import {Action} from "redux";

import {
    GetProjectDetailByClientRequest,
    CreateProjectDetailByClientRequest,
    UpdateProjectDetailByClientRequest,
    DraftProjectDetailByClientRequest,
    OpenProjectDetailByClientRequest,
    CloseProjectDetailByClientRequest,
} from "../request/project_request";
import {
    GetProjectDetailByClientResponse,
    CreateProjectDetailByClientResponse,
    UpdateProjectDetailByClientResponse,
} from "../response/project_response";

export enum ClientProjectDetailActionType {
    REQUEST_GET_PROJECT = "CLIENT_PROJECT_DETAIL_REQUEST_GET_PROJECT",
    CALLBACK_GET_PROJECT = "CLIENT_PROJECT_DETAIL_CALLBACK_GET_PROJECT",
    REQUEST_CREATE_PROJECT = "CLIENT_PROJECT_DETAIL_REQUEST_CREATE_PROJECT",
    CALLBACK_CREATE_PROJECT = "CLIENT_PROJECT_DETAIL_CALLBACK_CREATE_PROJECT",
    REQUEST_UPDATE_PROJECT = "CLIENT_PROJECT_DETAIL_REQUEST_UPDATE_PROJECT",
    CALLBACK_UPDATE_PROJECT = "CLIENT_PROJECT_DETAIL_CALLBACK_UPDATE_PROJECT",
    REQUEST_DRAFT_PROJECT = "CLIENT_PROJECT_DETAIL_REQUEST_DRAFT_PROJECT",
    CALLBACK_DRAFT_PROJECT = "CLIENT_PROJECT_DETAIL_CALLBACK_DRAFT_PROJECT",
    REQUEST_OPEN_PROJECT = "CLIENT_PROJECT_DETAIL_REQUEST_OPEN_PROJECT",
    CALLBACK_OPEN_PROJECT = "CLIENT_PROJECT_DETAIL_CALLBACK_OPEN_PROJECT",
    REQUEST_CLOSE_PROJECT = "CLIENT_PROJECT_DETAIL_REQUEST_CLOSE_PROJECT",
    CALLBACK_CLOSE_PROJECT = "CLIENT_PROJECT_DETAIL_CALLBACK_CLOSE_PROJECT",
}

export interface IRequestGetProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.REQUEST_GET_PROJECT;
    item: GetProjectDetailByClientRequest;
}

export interface ICallbackGetProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.CALLBACK_GET_PROJECT;
    isSuccess: boolean;
    item?: GetProjectDetailByClientResponse;
    error?: any;
}

export interface IRequestCreateProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.REQUEST_CREATE_PROJECT;
    item: CreateProjectDetailByClientRequest;
}

export interface ICallbackCreateProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.CALLBACK_CREATE_PROJECT;
    isSuccess: boolean;
    item?: CreateProjectDetailByClientResponse;
    error?: any;
}

export interface IRequestUpdateProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.REQUEST_UPDATE_PROJECT;
    item: UpdateProjectDetailByClientRequest;
}

export interface ICallbackUpdateProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.CALLBACK_UPDATE_PROJECT;
    isSuccess: boolean;
    item?: UpdateProjectDetailByClientResponse;
    error?: any;
}

export interface IRequestDraftProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.REQUEST_DRAFT_PROJECT;
    item: DraftProjectDetailByClientRequest;
}

export interface ICallbackDraftProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.CALLBACK_DRAFT_PROJECT;
    isSuccess: boolean;
    error?: any;
}

export interface IRequestOpenProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.REQUEST_OPEN_PROJECT;
    item: OpenProjectDetailByClientRequest;
}

export interface ICallbackOpenProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.CALLBACK_OPEN_PROJECT;
    isSuccess: boolean;
    error?: any;
}

export interface IRequestCloseProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.REQUEST_CLOSE_PROJECT;
    item: CloseProjectDetailByClientRequest;
}

export interface ICallbackCloseProjectDetailAction extends Action {
    type: ClientProjectDetailActionType.CALLBACK_CLOSE_PROJECT;
    isSuccess: boolean;
    error?: any;
}

export type ClientProjectDetailAction =
    IRequestGetProjectDetailAction |
    ICallbackGetProjectDetailAction |
    IRequestCreateProjectDetailAction |
    ICallbackCreateProjectDetailAction |
    IRequestUpdateProjectDetailAction |
    ICallbackUpdateProjectDetailAction |
    IRequestDraftProjectDetailAction |
    ICallbackDraftProjectDetailAction |
    IRequestOpenProjectDetailAction |
    ICallbackOpenProjectDetailAction |
    IRequestCloseProjectDetailAction |
    ICallbackCloseProjectDetailAction
    ;

export interface IClientProjectDetailActionCreator {
    requestGetProjectDetailAction(
        item: GetProjectDetailByClientRequest,
    ): IRequestGetProjectDetailAction;

    callbackGetProjectDetailAction(
        isSuccess: boolean,
        item?: GetProjectDetailByClientResponse,
    ): ICallbackGetProjectDetailAction;

    requestCreateProjectDetailAction(
        item: CreateProjectDetailByClientRequest,
    ): IRequestCreateProjectDetailAction;

    callbackCreateProjectDetailAction(
        isSuccess: boolean,
        item?: CreateProjectDetailByClientResponse,
    ): ICallbackCreateProjectDetailAction;

    requestUpdateProjectDetailAction(
        item: UpdateProjectDetailByClientRequest
    ): IRequestUpdateProjectDetailAction;

    callbackUpdateProjectDetailAction(
        isSuccess: boolean,
        item?: UpdateProjectDetailByClientResponse,
    ): ICallbackUpdateProjectDetailAction;

    requestDraftProjectDetailAction(
        item: DraftProjectDetailByClientRequest,
    ): IRequestDraftProjectDetailAction;

    callbackDraftProjectDetailAction(
        isSuccess: boolean,
    ): ICallbackDraftProjectDetailAction;

    requestOpenProjectDetailAction(
        item: OpenProjectDetailByClientRequest,
    ): IRequestOpenProjectDetailAction;

    callbackOpenProjectDetailAction(
        isSuccess: boolean,
    ): ICallbackOpenProjectDetailAction;

    requestCloseProjectDetailAction(
        projectId: CloseProjectDetailByClientRequest,
    ): IRequestCloseProjectDetailAction;

    callbackCloseProjectDetailAction(
        isSuccess: boolean,
    ): ICallbackCloseProjectDetailAction;

}

class ActionCreator implements IClientProjectDetailActionCreator {

    public requestGetProjectDetailAction = (
        item: GetProjectDetailByClientRequest,
    ): IRequestGetProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.REQUEST_GET_PROJECT,
            item,
        };
    };

    public callbackGetProjectDetailAction = (
        isSuccess: boolean,
        item?: GetProjectDetailByClientResponse,
    ): ICallbackGetProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.CALLBACK_GET_PROJECT,
            isSuccess,
            item,
        };
    };

    public requestCreateProjectDetailAction = (
        item: CreateProjectDetailByClientRequest,
    ): IRequestCreateProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.REQUEST_CREATE_PROJECT,
            item,
        };
    };

    public callbackCreateProjectDetailAction = (
        isSuccess: boolean,
        item?: CreateProjectDetailByClientResponse,
    ): ICallbackCreateProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.CALLBACK_CREATE_PROJECT,
            isSuccess,
            item,
        };
    };

    public requestUpdateProjectDetailAction = (
        item: UpdateProjectDetailByClientRequest,
    ): IRequestUpdateProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.REQUEST_UPDATE_PROJECT,
            item,
        };
    };

    public callbackUpdateProjectDetailAction = (
        isSuccess: boolean,
        item?: UpdateProjectDetailByClientResponse,
    ): ICallbackUpdateProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.CALLBACK_UPDATE_PROJECT,
            isSuccess,
            item,
        };
    };

    public requestDraftProjectDetailAction = (
        item: DraftProjectDetailByClientRequest,
    ): IRequestDraftProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.REQUEST_DRAFT_PROJECT,
            item,
        };
    };

    public callbackDraftProjectDetailAction = (
        isSuccess: boolean,
    ): ICallbackDraftProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.CALLBACK_DRAFT_PROJECT,
            isSuccess,
        };
    };

    public requestOpenProjectDetailAction = (
        item: OpenProjectDetailByClientRequest,
    ): IRequestOpenProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.REQUEST_OPEN_PROJECT,
            item,
        };
    };

    public callbackOpenProjectDetailAction = (
        isSuccess: boolean,
    ): ICallbackOpenProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.CALLBACK_OPEN_PROJECT,
            isSuccess,
        };
    };

    public requestCloseProjectDetailAction = (
        item: CloseProjectDetailByClientRequest,
    ): IRequestCloseProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.REQUEST_CLOSE_PROJECT,
            item,
        };
    };

    public callbackCloseProjectDetailAction = (
        isSuccess: boolean,
    ): ICallbackCloseProjectDetailAction => {
        return {
            type: ClientProjectDetailActionType.CALLBACK_CLOSE_PROJECT,
            isSuccess,
        };
    };

}

export const createClientProjectDetailActionCreator = (): IClientProjectDetailActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_project_action.ts